// Small action capsule ("Buy", "Book", "Join"…) overlaid on the bottom-right
// corner of a card's image. Purely visual: the whole card is the tap target,
// so taps on the capsule bubble up to the card's own onClick.
const SIZES = {
  md: 'px-3.5 py-1.5 text-[11px]',
  sm: 'px-2.5 py-1 text-[10px]',
};

export default function CardCapsule({ label, testId, position = 'bottom-2 right-2', size = 'md' }) {
  return (
    <span
      aria-hidden="true"
      data-testid={testId}
      className={`absolute ${position} inline-flex items-center rounded-full bg-[#2B3A67] font-extrabold uppercase tracking-wider text-white shadow-md ring-2 ring-white/90 ${SIZES[size]}`}
      style={{ fontFamily: "'Outfit', sans-serif" }}
    >
      {label}
    </span>
  );
}
